enum AttachmentType {
	Undefined = 0,
	DriverLicense = 100,
	ProofOfEmployment = 200,
	ProofOfResidency = 400,
	VehicleRegistration = 500,
	FamilyVehicle = 501,
	BusinessVehicle = 502,
	OverweightVehicle = 503,
	BankTransferId = 600,
	ParkingGeometryMap = 700,
	MiscellaneousDocument = 701
}

export default AttachmentType;
